import { BannerAnchor, BannerContent, Banner as _Banner } from './banner';

/**
 * A dismissible page banner component that fills the entire viewport width.
 * Uses Radix UI Popover primitives for proper accessibility.
 *
 * @example
 *      <Banner isOpen={isBannerOpen} onDismiss={() => setIsBannerOpen(false)}>
 *        <Banner.Anchor>
 *          <Navbar
 *            avatarLabel="John Doe"
 *            onInviteSubmission={async (data, onSuccess, onError) => {
 *              await new Promise((resolve) => setTimeout(resolve, 1000));
 *              onSuccess();
 *              onError();
 *            }}
 *          >
 *            <NavbarItem to={'/'}>Home</NavbarItem>
 *            <NavbarItem to={'/about'}>About</NavbarItem>
 *            <NavbarItem to={'/contact'}>Contact</NavbarItem>
 *          </Navbar>
 *        </Banner.Anchor>
 *        <Banner.Content>Welcome to our new feature! Check out what's new.</Banner.Content>
 *      </Banner>
 */
const Banner = Object.assign(_Banner, {
  /**
   * The content of the banner
   */
  Content: BannerContent,
  /**
   * The anchor of the banner
   */
  Anchor: BannerAnchor,
});

export type { BannerProps, BannerContentProps, BannerAnchorProps } from './banner';
export { Banner };
